// extracted by mini-css-extract-plugin
export var list = "switcher-module--list--db615";
export var listActiveItem = "switcher-module--list-active-item--1819b";
export var listItem = "switcher-module--list-item--cbf67";
export var lowerHolder = "switcher-module--lower-holder--c3d8d";
export var topWrapper = "switcher-module--top-wrapper--5c165";
export var trainingTypeItem = "switcher-module--training-type-item--664f4";
export var underLine = "switcher-module--under-line--f6e64";